import { CircularProgress, FormControl, Grid, IconButton, InputAdornment, TextField, Typography } from '@mui/material'
import { CustomTimeline } from 'common'
import React from 'react'
import { Send } from 'react-feather'

export const ObservationsCredit = (props) => {

  const {formState, onInputChange, onSendLogs, observations, sending} = props

  return (
    <>
        <Typography sx={{mt:3,fontWeight: 'bold'}} variant='subtitle2'>
            Observaciones
        </Typography>
        <div className="border-bottom border-dark"></div>
        <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ mt: 2 }}>
            <CustomTimeline
              observations={observations.data}
            />
            <Grid item xs={12} sm={12} md={12} lg={12} sx={{ mb: 1, mt: 2 }}>
              <FormControl fullWidth>
                  <label htmlFor="aprobacion_observaciones">Observaciones</label>

                  <TextField
                      id='aprobacion_observaciones'
                      name='aprobacion_observaciones'
                      value={ formState.aprobacion_observaciones } 
                      onChange={onInputChange}
                      size='small'
                      placeholder=''
                      type='text'
                      multiline
                      rows={4}
                      variant='outlined'
                      InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                aria-label="send message"
                                onClick={onSendLogs}
                                disabled={sending}
                              >
                                {sending ? <CircularProgress size={20} color="inherit" /> : <Send />}
                              </IconButton>
                            </InputAdornment>
                          )
                      }}
                  />
              </FormControl>
            </Grid> 
        </Grid>
    </>
  )
}
